import { render, staticRenderFns } from "./MetadataList.html?vue&type=template&id=7a8e9a54&scoped=true&"
import script from "./MetadataList.vue?vue&type=script&lang=js&"
export * from "./MetadataList.vue?vue&type=script&lang=js&"
import style0 from "./MetadataList.vue?vue&type=style&index=0&id=7a8e9a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8e9a54",
  null
  
)

export default component.exports